import { useRef } from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';

const LazyLoadComponent = ({ root, threshold, rootMargin, forward, cmp }) => {
  const ref = useRef(null);
  const isIntersecting = useIntersectionObserver(
    ref,
    {
      root: root ?? null,
      threshold: threshold ?? 0,
      rootMargin: rootMargin,
    },
    forward
  );

  return <div ref={ref}>{isIntersecting ? cmp : null}</div>;
};

export default LazyLoadComponent;
